import { TFunction } from 'i18next';

export const getQuestions = (t: TFunction) =>
  [...Array(18)].map((_, index) =>
    t(`asset-overview:documentAssistant.question_${index}`)
  );
